/**
 * @generated SignedSource<<148dac729c9bf5d52c1efce0d5f4984a>>
 * @relayHash 42eb6697cfb60308595171e6bae8f6c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4e02dabb357e0e21a92c654403aae04f2ca3ddb1a05b83a5a76e55fff55865a9

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceContentRestrictionState = "EDIT_RESTRICTED" | "OPEN" | "RESTRICTED_BY_PARENT" | "VIEW_RESTRICTED" | "%future added value";
export type ConfluenceContentRestrictionStateInput = "EDIT_RESTRICTED" | "OPEN" | "VIEW_RESTRICTED" | "%future added value";
export type ConfluenceSetContentGeneralAccessModeInput = {
  contentId: string;
  mode: ConfluenceContentRestrictionStateInput;
};
export type useSetContentGeneralAccessModeMutation$variables = {
  cloudId: string;
  input: ConfluenceSetContentGeneralAccessModeInput;
};
export type useSetContentGeneralAccessModeMutation$data = {
  readonly confluence_setContentGeneralAccessMode: {
    readonly contentGeneralAccess: {
      readonly mode: ConfluenceContentRestrictionState | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useSetContentGeneralAccessModeMutation = {
  response: useSetContentGeneralAccessModeMutation$data;
  variables: useSetContentGeneralAccessModeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceSetContentGeneralAccessModePayload",
    "kind": "LinkedField",
    "name": "confluence_setContentGeneralAccessMode",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceContentGeneralAccess",
        "kind": "LinkedField",
        "name": "contentGeneralAccess",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "mode"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSetContentGeneralAccessModeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSetContentGeneralAccessModeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "42eb6697cfb60308595171e6bae8f6c3",
    "id": "4e02dabb357e0e21a92c654403aae04f2ca3ddb1a05b83a5a76e55fff55865a9",
    "metadata": {},
    "name": "useSetContentGeneralAccessModeMutation",
    "operationKind": "mutation",
    "text": "mutation useSetContentGeneralAccessModeMutation($cloudId:ID!,$input:ConfluenceSetContentGeneralAccessModeInput!){confluence_setContentGeneralAccessMode(cloudId:$cloudId,input:$input){contentGeneralAccess{mode},success,errors{message}}}"
  }
};
})();

(node as any).hash = "80359d53cb5c8ced19aa5353c4cfec42";

export default node;
